// src/hooks/useSenders.js
import { useState, useEffect } from 'react';
import apiClient from '../api/client';

export const useSenders = () => {
  const [senders, setSenders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSenders = async () => {
      try {
        setIsLoading(true);
        const response = await apiClient.get('/email-senders');
        setSenders(response.data);
      } catch (err) {
        console.error('Error fetching email senders:', err);
        setError(err);
        // Provide some defaults for development
        setSenders([
          { id: '1', display_name: 'Marketing Team', email: 'marketing@example.com' },
          { id: '2', display_name: 'Support', email: 'support@example.com' },
          { id: '3', display_name: 'Appointments', email: 'appointments@example.com' }
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSenders();
  }, []);

  return { senders, isLoading, error };
};

export default useSenders;